import React, {Component} from "react";
import SimpleModal from "../../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import {mapToObjectDDL} from "../../../../../common/mapper";
import Api from "../../../../../../Services/Api";

class InventoryUnitFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataVariant: [],
            dataWarna: [],
            dataSegment: [],
            dataLocator: [],
        };
    }

    componentDidMount() {
        this.fetchDataVarian();
        this.fetchDataWarna();
        this.fetchDataSegment();
        this.fetchDataLocator();
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit();
    };

    fetchDataVarian = async () => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant()
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataVariant: response.data.data,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataWarna = async () => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllWarna({distinct:true})
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataWarna: response.data.data,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataSegment = async () => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllSegmen()
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataSegment: response.data.data,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataLocator = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam({
                paramFilters: {kodeCabang: this.props.selectedCabang?.value},
                page: null,
                limit: null
            })

            if (res.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataLocator: res.data.data
                }));
            }

        } catch (error) {
            console.log("errors: ", error);
        }
    }

    render() {
        return (
            <SimpleModal
                title="Filter"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <form onSubmit={this.handleSubmit}>
                            <SimpleDDL
                                id="select_options_filter_kode_variant"
                                box="search"
                                name="kodeVarian"
                                label="Kode Varian"
                                isClearable={true}
                                options={this.state.dataVariant ? this.state.dataVariant.map(
                                    item => ({
                                        label: item.kodeVariant,
                                        value: item.kodeVariant,
                                        name: item.namaVariant
                                    })) : null}
                                value={this.props.filterData.kodeVarian}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleInput
                                id="input_text_nama_variant"
                                name="nameVariant"
                                label="Nama Varian"
                                readOnly={true}
                                value={this.props.filterData.kodeVarian ? this.props.filterData.kodeVarian.name : ""}
                            />
                            <SimpleDDL
                                id="select_options_filter_kode_warna"
                                box="search"
                                name="kodeWarna"
                                label="Kode Warna"
                                isClearable={true}
                                options={this.state.dataWarna ? this.state.dataWarna.map(
                                    item => ({
                                        label: item.kodeWarna,
                                        value: item.kodeWarna,
                                        name: item.namaWarnaKomersil
                                    })) : null}
                                value={this.props.filterData.kodeWarna}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleInput
                                id="input_text_nama_warna"
                                name="namaWarna"
                                label="Nama Warna"
                                readOnly={true}
                                value={this.props.filterData.kodeWarna ? this.props.filterData.kodeWarna.name : ""}
                            />
                            <SimpleDDL
                                id="select_options_filter_segment"
                                box="search"
                                name="kodesegmen"
                                label="Segmen"
                                isClearable={true}
                                options={this.state.dataSegment ? this.state.dataSegment.map(
                                    item => mapToObjectDDL(
                                        item.segmentName,
                                        item.id.toString(),
                                    )) : null}
                                value={this.props.filterData.kodesegmen}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_filter_lcoator"
                                box="search"
                                name="kodeLocation"
                                label="Locator"
                                isClearable={true}
                                options={this.state.dataLocator ? this.state.dataLocator.map(
                                    item => mapToObjectDDL(
                                        item.nameLocation,
                                        item.kodeLocation
                                    )) : null}
                                value={this.props.filterData.kodeLocation}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />

                            <h3>Filter Detail</h3>
                            <SimpleInput
                                id="input_text_no_mesin"
                                name="noMesin"
                                label="Nomor Mesin"
                                value={this.props.filterData.noMesin}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value?.trim())
                                }
                            />
                            <SimpleInput
                                id="input_text_no_rangka"
                                name="noRangka"
                                label="Nomor Rangka"
                                value={this.props.filterData.noRangka}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value?.trim())
                                }
                            />
                            <SimpleDDL
                                id="select_options_filter_status_rfs"
                                box="search"
                                name="satuanRfs"
                                label="Status RFS"
                                isClearable={true}
                                options={[{value: "RFS", label: "RFS"}, {value: "NRFS", label: "NRFS"}]}
                                value={this.props.filterData.satuanRfs}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleInput
                                id="input_text_umur"
                                name="umur"
                                label="Umur >"
                                value={this.props.filterData.umur}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />

                            <FlexView hAlignContent="right">
                                <SimpleButton type="button" secondary onClick={() => this.props.onClearForm()}>
                                    Hapus
                                </SimpleButton>
                                <SimpleButton type="submit">Terapkan</SimpleButton>
                            </FlexView>
                        </form>
                    </ModalContainer>
                }
            />
        );
    }
}

export default InventoryUnitFilter;